// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-with-toggle[data-v-6b19730a] {\n  position: relative;\n}\n.toggle-table-setting[data-v-6b19730a] {\n  position: absolute;\n  top: 9px;\n  right: 0;\n  height: 40px;\n  width: 40px;\n  z-index: 1;\n}\n.toggle-table-setting[data-v-6b19730a]:focus::after {\n  opacity: 0 !important;\n}", ""]);
// Exports
module.exports = exports;
